import React from "react";
import "./footer.scss";
import logo from "../../Media/KHI_Green.png";
import {Link} from "react-router-dom";

const footer = () => {
  return (
    <div className="container-footer">
      <div className="container-atas">
        <div className="container-logo">
          <img className="gambar-logo" src={logo} alt="logo-Parkspring" />
        </div>
        <div className="container-deskripsi">
          <div className="alamat">
            <h1>Marketing Gallery</h1>
            <h2>Kota Harapan Indah</h2>
            <h3>
              Jl. Harapan Indah Boulevard, RT.005/RW.010, Medan Satria,
              Kecamatan Medan Satria, Kota Bks, Jawa Barat 17132
            </h3>
            <h4>Contact us : +6281311110717</h4>
            <Link to="/privacy-policy">
              <div className="footer-contact">Privacy Policy</div>
            </Link>
          </div>
          <div className="privasi"></div>
        </div>
      </div>
      <div className="container-bawah">© Kota Harapan Indah</div>
    </div>
  );
};

export default footer;
